import { render, staticRenderFns } from "./ContentTypeFieldsModal.vue?vue&type=template&id=f8193972&scoped=true"
import script from "./ContentTypeFieldsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentTypeFieldsModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContentTypeFieldsModal.vue?vue&type=style&index=0&id=f8193972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8193972",
  null
  
)

export default component.exports